<p-panel [showHeader]="false" class="h-full flex flex-col navigation-panel">
  <!-- HEADER -->
  <div class="flex justify-between items-center" [class.hidden]="isMobileView() && isAnyMobileFullViewOpen()">
    <div class="flex items-center">
      <a (click)="onClickMenuEvent()" [routerLink]="['/' + routes.homePath]">
        <img class="lg:size-12 size-8" src="https://www.acp-gruppe.com/hs-fs/hubfs/acp_logo_rgb_small.png?width=70&height=69&name=acp_logo_rgb_small.png" alt="ACP Logo" />
      </a>
      <h1 class="ml-4 font-semibold">{{ "projectName" | translate }}</h1>
    </div>

    <button (click)="toggleDesktopSidebar()" [ngClass]="{'!hidden': isMobileView()}" class="icon-with-circle hidden lg:flex items-center justify-center cursor-pointer border rounded-full size-8" type="button" aria-label="Toggle Menu">
      <i [class]="desktopSidebarOpen() ? 'pi pi-chevron-up text-xs' : 'pi pi-chevron-down text-xs'"></i>
    </button>

    @if (isMobileView()) {
    <div class="flex items-center gap-2">
      <gate-menu
        class="lg:hidden"
        [mobileFullView]="true"
        (openSettingsFullView)="openSettingsView()"
        (openCartFullView)="openCartView()"></gate-menu>
      <button type="button" class="mobile-header-close-button" (click)="closeMobileMenu()" [attr.aria-label]="'closeButton' | translate">
        <i class="pi pi-times"></i>
      </button>
    </div>
    }
  </div>

  <!-- NAVIGATION -->
  <nav
    class="mt-3 text-sm navigation-bar flex-1"
    [ngClass]="{
      'navigation-bar-mobile-with-customer': isMobileView() && showMobileCustomerTrigger() && !isSectionOpen('customers'),
      'navigation-bar-mobile-image-only': isMobileView() && !showMobileCustomerTrigger() && !isSectionOpen('customers')
    }">
    @if (isMobileView() && isSectionOpen('settings')) {
      <div class="mobile-customer-fullview">
        <div class="mobile-customer-fullview-header">
          <div class="flex min-w-0 items-center gap-3">
            <button type="button" class="mobile-back-button" (click)="closeSettingsView()">
              <i class="pi pi-arrow-left"></i>
            </button>
            <div class="mobile-customer-fullview-title">{{ 'menu.profile' | translate }}</div>
          </div>
          <button type="button" class="mobile-header-close-button" (click)="closeMobileMenu()" [attr.aria-label]="'closeButton' | translate">
            <i class="pi pi-times"></i>
          </button>
        </div>
        <div class="mobile-customer-list">
          <button type="button" class="mobile-customer-item" (click)="navigateToProfile()">
            <span>{{ 'menu.profile' | translate }}</span>
          </button>
          <button type="button" class="mobile-customer-item" (click)="navigateToMasterData()">
            <span>{{ 'menu.masterData' | translate }}</span>
          </button>
          <button type="button" class="mobile-customer-item" (click)="navigateToFeedback()">
            <span>{{ 'menu.feedback' | translate }}</span>
          </button>
          <ng-container *gatePermission="[role.GatePartnerApiRead]; type: 'role'">
            <button type="button" class="mobile-customer-item" (click)="navigateApiDocumentation()">
              <span>{{ 'menu.apiDocumentation' | translate }}</span>
            </button>
          </ng-container>
          <div class="mobile-customer-item">
            <span>{{ 'menu.darkLightMode' | translate }}</span>
            <span class="flex items-center justify-between" style="width: 90px;">
              <i class="pi pi-moon"></i>
              <p-toggleswitch [(ngModel)]="isLightMode" (onChange)="toggleDarkMode()" />
              <i class="pi pi-sun"></i>
            </span>
          </div>
          <div class="mobile-customer-item">
            <span>{{ 'menu.language.lang' | translate }}</span>
            <span class="flex items-center justify-between" style="width: 90px;">
              <i>{{ 'menu.language.en' | translate }}</i>
              <p-toggleswitch (onChange)="toggleLanguage()" [ngModel]="locale() == 'en-US' ? false : true" />
              <i>{{ 'menu.language.de' | translate }}</i>
            </span>
          </div>
          <div class="mobile-customer-item">
            <span>{{ (isHeroVisible() ? 'menu.hideHeroArea' : 'menu.showHeroArea') | translate }}</span>
            <span class="flex items-center justify-center" style="width: 90px;">
              <p-toggleswitch [ngModel]="isHeroVisible()" (onChange)="toggleHeroVisibility($event.checked)" />
            </span>
          </div>
          <button type="button" class="mobile-customer-item text-primary" (click)="logOut()">
            <span>{{ 'menu.logOut' | translate }}</span>
            <i class="pi pi-sign-out"></i>
          </button>
        </div>
      </div>
    } @else if (isMobileView() && isSectionOpen('cart')) {
      <div class="mobile-customer-fullview">
        <div class="mobile-customer-fullview-header">
          <div class="flex min-w-0 items-center gap-3">
            <button type="button" class="mobile-back-button" (click)="closeCartView()">
              <i class="pi pi-arrow-left"></i>
            </button>
            <div class="mobile-customer-fullview-title">{{ 'cart.title' | translate }}</div>
          </div>
          <button type="button" class="mobile-header-close-button" (click)="closeMobileMenu()" [attr.aria-label]="'closeButton' | translate">
            <i class="pi pi-times"></i>
          </button>
        </div>
        <div class="mobile-cart-fullview-content !block">
          <gate-shopping-cart-menu
            [inlinePanel]="true"
            (navigateToCart)="navigateToCart()"></gate-shopping-cart-menu>
        </div>
      </div>
    } @else if (isMobileView() && isSectionOpen('customers')) {
      <div class="mobile-customer-fullview">
        <div class="mobile-customer-fullview-header">
          <div class="flex min-w-0 items-center gap-3">
            <button type="button" class="mobile-back-button" (click)="closeCustomerView()">
              <i class="pi pi-arrow-left"></i>
            </button>
            <div class="mobile-customer-fullview-title">{{ 'menu.customerSelection' | translate }}</div>
          </div>
          <button type="button" class="mobile-header-close-button" (click)="closeMobileMenu()" [attr.aria-label]="'closeButton' | translate">
            <i class="pi pi-times"></i>
          </button>
        </div>
        <div class="mobile-customer-list">
          @for (item of customersMenuItem; track item.customerId) {
            <div class="mobile-customer-item" [class.is-active]="item.isCurrent" (click)="switchCustomer(item.customerId)">
              <div class="flex items-start gap-3 min-w-0">
                <button
                  type="button"
                  class="customer-preference-button mt-1"
                  (click)="setPreferredCustomer(item.customerId, $event)"
                  [disabled]="item.isLoading">
                  <i
                    class="pi"
                    [ngClass]="{
                      'pi-spinner pi-spin text-slate-400': item.isLoading,
                      'pi-heart-fill text-red-500': item.isPreferred,
                      'pi-heart text-slate-400': !item.isPreferred && !item.isLoading
                    }"></i>
                </button>
                <div class="min-w-0 flex-1 text-left">
                  <div class="line-clamp-2">{{ item.label }}</div>
                  <div class="text-xs text-slate-500 mt-1">{{ item.customerId }}</div>
                </div>
              </div>
              @if (item.isCurrent) {
                <i class="pi pi-check text-primary text-xs"></i>
              }
            </div>
          }
        </div>
      </div>
    } @else {
    <!-- DASHBOARD -->
    <ul>
      <li routerLinkActive="active" (click)="onClickMenuEvent()" [routerLink]="['/' + routes.homePath]">
        <a>
          <i class="pi pi-home"></i>
          {{ "menu.dashboard" | translate }}
        </a>
      </li>
    </ul>

    @if (isCustomer()) {

    <!-- PRODUCTS -->
    <hr class="my-4" />
    @if (isMobileView()) {
      <button type="button" class="mobile-section-toggle px-4" (click)="toggleSection('products')">
        <span>{{ "menu.product" | translate }}</span>
        <i class="pi" [ngClass]="isSectionOpen('products') ? 'pi-chevron-up' : 'pi-chevron-down'"></i>
      </button>
    } @else {
      <h2>{{ "menu.product" | translate }}</h2>
    }
    @if (!isMobileView() || isSectionOpen('products')) {
    <ul>
      <ng-container *gatePermission="[role.GateAssetsRead]; type: 'group'">
        <li class="cursor-not-allowed">
          <a class="text-disabled">
            <i class="pi pi-desktop"></i>
            {{ "menu.devices" | translate }}
          </a>
        </li>
      </ng-container>
      <ng-container *gatePermission="[role.GateLicensesRead, role.GateLicensesWrite]; type: 'group' match: 'any'">
        <li routerLinkActive="active" (click)="onClickMenuEvent()" [routerLink]="'/' + routes.licensePath">
          <a>
            <i class="pi pi-key"></i>
               {{ "menu.licenses" | translate }} 
          </a>
        </li>
      </ng-container>
      <li routerLinkActive="active" (click)="onClickMenuEvent()" [routerLink]="'/' + routes.marketplacePath">
        <a>
          <i class="pi pi-shopping-cart"></i>
          {{ "menu.marketplaces" | translate }}
        </a>
      </li>
    </ul>
    }

    <!-- SHOP -->
    <ng-container *gatePermission="[role.GateEcommerceAdmin, role.GateEcommerceOrderApprover, role.GateEcommerceOrderRequester, role.GateOffersWrite];
        match: 'any'
        type: 'group'">

      <hr class="my-4" />
      @if (isMobileView()) {
        <button type="button" class="mobile-section-toggle px-4" (click)="toggleSection('shop')">
          <span>{{ "menu.shop" | translate }}</span>
          <i class="pi" [ngClass]="isSectionOpen('shop') ? 'pi-chevron-up' : 'pi-chevron-down'"></i>
        </button>
      } @else {
        <h2>{{ "menu.shop" | translate }}</h2>
      }
      @if (!isMobileView() || isSectionOpen('shop')) {
      <ul>
        <ng-container *gatePermission="[role.GateEcommerceAdmin, role.GateEcommerceOrderApprover, role.GateEcommerceOrderRequester];
        match: 'any'
        type: 'group'">
          <li routerLinkActive="active" (click)="onClickMenuEvent()" [routerLink]="'/' + routes.catalogue()">
            <a>
              <i class="pi pi-shopping-bag"></i>
              {{ "menu.catalogue" | translate }}
            </a>
          </li>
        </ng-container>

        <ng-container *gatePermission="[role.GateEcommerceAdmin, role.GateEcommerceOrderApprover, role.GateEcommerceOrderRequester];
        match: 'any'
        type: 'group'">
          <li routerLinkActive="active" (click)="onClickMenuEvent()" [routerLink]="'/' + routes.cart()" [class.!h-auto]="cartItemCount() > 0" [class.!py-1.5]="cartItemCount() > 0" [class.!leading-normal]="cartItemCount() > 0">
            <a class="flex flex-col !gap-0 justify-center w-full">
              <div class="flex items-center justify-between w-full">
                <div class="flex items-center gap-3 min-w-0">
                  <i class="pi pi-shopping-cart"></i>
                  <span class="truncate font-medium">{{ "cart.title" | translate }}</span>
                </div>
                @if (cartItemCount() > 0) {
                  <span class="cart-count-badge" data-testid="sidebar-cart-count">
                    {{ cartItemCount() }}
                  </span>
                }
              </div>
              @if (cartItemCount() > 0) {
                <div class="flex items-center justify-start w-full pl-7 text-sm font-medium opacity-90 mt-0.5" data-testid="sidebar-cart-amount">
                  <span>{{ cartTotalPrice() | currency: 'EUR':'symbol':'1.2-2':locale() }}</span>
                </div>
              }
            </a>
          </li>
        </ng-container>

        <li routerLinkActive="active" (click)="onClickMenuEvent()" [routerLink]="'/' + routes.approval()">
          <a>
            <i class="pi pi-check-circle"></i>
            {{ "menu.approval" | translate }}
          </a>
        </li>
      </ul>
      }
    </ng-container>

    <!-- DOCUMENTS -->
    <ng-container *gatePermission="[role.GateOffersRead, role.GateOffersWrite, role.GateOffersReject,role.GateOrdersRead,role.GateInvoicesRead,role.GateDeliveryNotesRead,role.GateContractsRead,role.GateExternalContractsRead];
        match: 'any' type: 'group'">
      <hr class="my-4" />
      @if (isMobileView()) {
        <button type="button" class="mobile-section-toggle px-4" (click)="toggleSection('documents')">
          <span>{{ "menu.documents" | translate }}</span>
          <i class="pi" [ngClass]="isSectionOpen('documents') ? 'pi-chevron-up' : 'pi-chevron-down'"></i>
        </button>
      } @else {
        <h2>{{ "menu.documents" | translate }}</h2>
      }
      @if (!isMobileView() || isSectionOpen('documents')) {
      <ul>
        <!-- OFFERS -->
        <ng-container *gatePermission="[role.GateOffersRead, role.GateOffersWrite, role.GateOffersReject]; type: 'group' match:'any'">
          <li routerLinkActive="active" (click)="onClickMenuEvent()" [routerLink]="'/' + routes.offerPath">
            <a>
              <i class="pi pi-file"></i>
              {{ "menu.offers" | translate }}
            </a>
          </li>
        </ng-container>
        <!-- ORDERS -->
        <ng-container *gatePermission="[role.GateOrdersRead]; type: 'group'">


          <li routerLinkActive="active" (click)="onClickMenuEvent()" [routerLink]="'/' + routes.orderPath">
            <a>
              <i class="pi pi-shopping-bag"></i>
              {{ "menu.orders" | translate }}
            </a>
          </li>
        </ng-container>
        <!-- DELIVERY NOTES -->
        <ng-container *gatePermission="[role.GateDeliveryNotesRead]; type: 'group'">

          <li routerLinkActive="active" (click)="onClickMenuEvent()" [routerLink]="'/' + routes.deliveryNotePath">
            <a>
              <i class="pi pi-truck"></i>
              {{ "menu.deliveryNotes" | translate }}
            </a>
          </li>
        </ng-container>
        <!-- INVOICES -->
        <ng-container *gatePermission="[role.GateInvoicesRead]; type: 'group'">


          <li routerLinkActive="active" (click)="onClickMenuEvent()" [routerLink]="'/' + routes.invoicePath">
            <a>
              <i class="pi pi-file-pdf"></i>
              {{ "menu.invoices" | translate }}
            </a>
          </li>

        </ng-container>
        <!-- CONTRACTS-->
        <ng-container *gatePermission="[role.GateContractsRead]; type: 'group'">
          <li routerLinkActive="active" (click)="onClickMenuEvent()" [routerLink]="'/' + routes.contractPath">
            <a>
              <i class="pi pi-briefcase"></i>
              {{ "menu.contracts" | translate }}
            </a>
          </li>
        </ng-container>
        <!-- EXTERNAL CONTRACTS-->
        <ng-container *gatePermission="[role.GateExternalContractsRead]; type: 'group'">
          <li routerLinkActive="active" (click)="onClickMenuEvent()" [routerLink]="'/' + routes.externalContractPath">
            <a>
              <i class="pi pi-briefcase"></i>
              {{ "menu.externalContracts" | translate }}
            </a>
          </li>
        </ng-container>
      </ul>
      }
    </ng-container>

    <!-- SUPPORT -->
    <hr class="my-4" />
    @if (isMobileView()) {
      <button type="button" class="mobile-section-toggle px-4" (click)="toggleSection('service')">
        <span>{{ "menu.service" | translate }}</span>
        <i class="pi" [ngClass]="isSectionOpen('service') ? 'pi-chevron-up' : 'pi-chevron-down'"></i>
      </button>
    } @else {
      <h2>{{ "menu.service" | translate }}</h2>
    }
    @if (!isMobileView() || isSectionOpen('service')) {
    <ul>
      <ng-container *gatePermission="[role.GateCasesReadAll, role.GateCasesRead]; type: 'group' match:'any'; bypass: isCompanyImpersonatedByAcpUser()">
        <li routerLinkActive="active" (click)="onClickMenuEvent()" [routerLink]="'/' + routes.serviceCase()" ariaCurrentWhenActive="page" [queryParams]="isCompanyImpersonatedByAcpUser() ? { isShowingAllCases: true } : null">

          <a>
            <i class="pi pi-headphones"></i>
            {{ "menu.serviceCases" | translate }}
          </a>
        </li>
      </ng-container>

      <ng-container *gatePermission="[role.GateBalanceRead,role.GateBalanceWriteInfo]; type: 'group'; match:'any'">

        <li routerLinkActive="active" (click)="onClickMenuEvent()" [routerLink]="'/' + routes.creditPath">
          <a>
            <i class="pi pi-wallet"></i>
            {{ "menu.serviceCredit" | translate }}
          </a>
        </li>
      </ng-container>

      <li (click)="navigateThreatTicker()">
        <a>
          <i class="pi pi-external-link"></i>
          {{ "menu.threatTicker" | translate }}
        </a>
      </li>
    </ul>
    }

    <!-- REPORTS -->
    <ng-container *gatePermission="[role.GateStockRead, role.GateServiceReportsRead]; match:'any' type:'group'">

      <hr class="my-4" />
      @if (isMobileView()) {
        <button type="button" class="mobile-section-toggle px-4" (click)="toggleSection('reports')">
          <span>{{ "menu.reports" | translate }}</span>
          <i class="pi" [ngClass]="isSectionOpen('reports') ? 'pi-chevron-up' : 'pi-chevron-down'"></i>
        </button>
      } @else {
        <h2>{{ "menu.reports" | translate }}</h2>
      }
      @if (!isMobileView() || isSectionOpen('reports')) {
      <ul>
        <ng-container *gatePermission="[role.GateStockRead]; type: 'group'">
          <li routerLinkActive="active" (click)="onClickMenuEvent()" [routerLink]="'/' + routes.inventoryPath">
            <a>
              <i class="pi pi-database"></i>
              {{ "menu.stockLevel" | translate }}
            </a>
          </li>
        </ng-container>

        <ng-container *gatePermission="[role.GateServiceReportsRead]; type: 'group'">
          <li routerLinkActive="active" (click)="onClickMenuEvent()" [routerLink]="'/' + routes.serviceReportPath">
            <a>
              <i class="pi pi-chart-bar"></i>
              {{ "menu.serviceReports" | translate }}
            </a>
          </li>
        </ng-container>

      </ul>
      }
    </ng-container>

    }

    <!-- USER MANAGEMENT -->
    <ng-container *gatePermission="[role.Customer]">
      <ng-container *gatePermission="[role.GateGroupAdmin, role.GateGroupRead]; match:'any' type:'group'">
        <hr class="my-4" />
        @if (isMobileView()) {
          <button type="button" class="mobile-section-toggle px-4" (click)="toggleSection('userManagement')">
            <span>{{ "menu.userManagement" | translate }}</span>
            <i class="pi" [ngClass]="isSectionOpen('userManagement') ? 'pi-chevron-up' : 'pi-chevron-down'"></i>
          </button>
        } @else {
          <h2>{{ "menu.userManagement" | translate }}</h2>
        }
        @if (!isMobileView() || isSectionOpen('userManagement')) {
        <ul>
          <li routerLinkActive="active" (click)="onClickMenuEvent()" [routerLink]="'/' + routes.customersUser()">
            <a>
              <i class="pi pi-users"></i>
              {{ "menu.users" | translate }}
            </a>
          </li>
        </ul>
        }
      </ng-container>
    </ng-container>

    <!-- CUSTOMER ADMIN -->
    <ng-container *gatePermission="[role.AccountManager],type: 'role'">
      <hr class="my-4" />
      @if (isMobileView()) {
        <button type="button" class="mobile-section-toggle px-4" (click)="toggleSection('customerAdministration')">
          <span>{{ "menu.customerAdministration" | translate }}</span>
          <i class="pi" [ngClass]="isSectionOpen('customerAdministration') ? 'pi-chevron-up' : 'pi-chevron-down'"></i>
        </button>
      } @else {
        <h2>{{ "menu.customerAdministration" | translate }}</h2>
      }
      @if (!isMobileView() || isSectionOpen('customerAdministration')) {
      <ul>
        <li routerLinkActive="active" (click)="onClickMenuEvent()" [routerLink]="'/' + routes.customersPath">
          <a>
            <i class="pi pi-building"></i>
            {{ "menu.customerOverview" | translate }}
          </a>
        </li>
        <ng-container *gatePermission="[role.ModuleAdmin],type: 'role'">
          <li routerLinkActive="active" (click)="onClickMenuEvent()" [routerLink]="'/' + routes.userAdministrationPath">
            <a>
              <i class="pi pi-users"></i>
              {{ "menu.userAdministration" | translate }}
            </a>
          </li>
        </ng-container>
        <li routerLinkActive="active" (click)="onClickMenuEvent()" [routerLink]="'/' + routes.launchpadPath">
          <a>
            <i class="pi pi-th-large"></i>
            {{ "menu.launchpad" | translate }}
          </a>
        </li>
        <ng-container *gatePermission="[role.ModuleAdmin],type: 'role'">
          <li routerLinkActive="active" (click)="onClickMenuEvent()" [routerLink]="'/' + routes.modulePath">
            <a>
              <i class="pi pi-cog"></i>
              {{ "menu.moduleManagement" | translate }}
            </a>
          </li>
        </ng-container>
      </ul>
      }
    </ng-container>

    <hr class="my-4" />
    <ul>
      <li routerLinkActive="active" #feedbackLink="routerLinkActive" (click)="onClickMenuEvent()" [routerLink]="'/' + routes.feedbackPath" ariaCurrentWhenActive="page">
        <a>
          <img [src]="feedbackLink.isActive ? 'assets/icons/communication_w_1000px_rgb.png' : 'assets/icons/communication_r_1000px_rgb.png'" alt="feedback" class="w-5 h-5" />
          {{ "menu.feedback" | translate }}
        </a>
      </li>
    </ul>
    <ng-container *gatePermission="[role.GatePartnerApiRead]; type: 'role'">
      <ul>
        <li (click)="navigateApiDocumentation()">
          <a>
            <i class="pi pi-book"></i>
            {{ "menu.apiDocumentation" | translate }}
          </a>
        </li>
      </ul>
    </ng-container>
  }
  </nav>

  @if (isMobileView() && customersMenuItem.length > 0 && !isAnyMobileFullViewOpen()) {
    <div class="mobile-customer-footer px-2 pb-2">
      @if (isCustomerLoading || customerLogoUrl()) {
        <button
          type="button"
          class="flex min-h-[4.5rem] w-full items-center gap-3 rounded-lg border border-slate-200 bg-white px-3 py-3 text-left shadow-sm dark:border-slate-700 dark:bg-slate-900"
          (click)="openCustomerView()">

          <div class="flex min-w-0 shrink-0 items-center justify-center">
            @if (isCustomerLoading) {
              <div class="text-sm font-semibold"><i class="pi pi-spin pi-spinner"></i></div>
            } @else {
              <img
                [src]="customerLogoUrl()!"
                [alt]="currentCustomerName || currentCustomerId || 'Customer logo'"
                class="block max-h-10 max-w-[3.75rem] object-contain" />
            }
          </div>

          <div class="h-12 w-px shrink-0 bg-slate-300 dark:bg-slate-700"></div>

          <div class="min-w-0 flex-1">
            <div class="truncate text-sm font-medium leading-tight text-slate-800 dark:text-slate-100">
              {{ user().givenName }} {{ user().familyName }}
            </div>
            <div class="truncate text-xs leading-tight text-slate-500 dark:text-slate-400">{{ currentCustomerName || currentCustomerId }}</div>
            <div class="truncate text-xs leading-tight text-slate-600 dark:text-slate-300">({{ currentCustomerId }})</div>
          </div>

          <div class="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-slate-200 text-slate-600 dark:border-slate-700 dark:text-slate-200">
            <i class="pi pi-chevron-right text-sm"></i>
          </div>
        </button>
      } @else {
        <button type="button" class="mobile-customer-trigger" (click)="openCustomerView()">
          <div class="mobile-customer-trigger-content">
            <div class="mobile-customer-name">{{ currentCustomerName || currentCustomerId }}</div>
            <div class="mobile-customer-user">{{ user().givenName }} {{ user().familyName }} ({{ currentCustomerId }})</div>
          </div>
          <div class="mobile-customer-trigger-arrow">
            <i class="pi pi-chevron-right text-sm"></i>
          </div>
        </button>
      }
    </div>
  }

  <!-- FOOTER -->
  <div class="flex justify-center my-2" [class.hidden]="isMobileView() && isAnyMobileFullViewOpen()">
    <img src="/assets/footer.png" class="w-24" alt="ACP Logo" />
  </div>

</p-panel>
